module.exports = __webpack_public_path__ + "img/edit_d_active.5dc2ebd4.svg";